const INVENTORY_URL = '/inventory';

export function constructInventoryURL(marketId?: string) {
  return INVENTORY_URL + (marketId ? `/${marketId}` : '');
}

export function getInventoryUrl({
  market,
  searchParams,
}: {
  market?: string;
  searchParams?: string;
}) {
  return market
    ? `${INVENTORY_URL}/${market}?${searchParams ? searchParams : ''}`
    : `${INVENTORY_URL}?${searchParams ? searchParams : ''}`;
}
